// extracted by mini-css-extract-plugin
module.exports = {"actions":"MigrateTo360DialogPreflight_actions__xWee4","prompt":"MigrateTo360DialogPreflight_prompt__3R9cw","stepperWrap":"MigrateTo360DialogPreflight_stepperWrap__1UtFz"};